import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Tabs, Tab} from 'react-bootstrap'
import {push} from '../../core/redux/router'
import {connectForm, nodeHasValue} from '../../core/redux/form'
import {mediaQuery} from '../../core/browser'
import extract from '../../core/extract'
import {infoStatus} from '../../core/redux/status'
import SearchBar from '../../core/components/SearchBar'
import TypeaheadBar, {matcher} from '../../core/components/TypeaheadBar'
import Tags from '../../core/components/Tags'
import Icon from '../../core/components/Icon'
import {DEFAULT_QUERY, PROVIDER_CRITERIA_UPDATED, loadProviderStream} from '../actions'
import {ProviderCriteria} from '../models'
import i18n from '../i18n'
import style from './ProviderSearchBar.less'

class ProviderSearchBar extends Component {
    static propTypes = {
    }

    _search(event) {
        const {dispatch, location, criteria} = this.props

        if (event) {
            event.preventDefault()
        }
        
        return dispatch(loadProviderStream({...DEFAULT_QUERY, ...criteria})).then(() => {
            if (location.pathname != '/providers' || location.pathname != '/providerdirectory') {
                return dispatch(push('/*'))
            }
        })
    }

    _searchOnKeyPress(event) {
        if (event.key == 'Enter') {
            const {dispatch, location, criteria} = this.props

            return dispatch(loadProviderStream({...DEFAULT_QUERY, ...criteria})).then(() => {
                if (location.pathname != '/providers' || location.pathname != '/providerdirectory') {
                    return dispatch(push('/*'))
                }
            })
        }
    }

    render() {
        const {dispatch, form, criteria, location, reference} = this.props

        const activitySource = matcher({
            source: reference,
            identify: (a) => a.label
        })

        const tabTitle = (label, icon) => (
            <span className={style.tabTitle}>
                <Icon icon={icon} size='sm' />
                {label}
            </span>
        )

        const footer = nodeHasValue(form.activityUid) && (
            <div className={style.footer}>
                <Tags
                    label={i18n.activity + ' :'}
                    labelClassName='col-sm-2'
                    wrapperClassName='col-sm-10'
                    display={(a) => a.label}
                    {...form.activityUid()} />
            </div>
        )

        return (
        	<SearchBar
                footer={footer}
                placeholder={extract(i18n.searchStream, mediaQuery())}
                onClick={(e) => this._search(e)}
                onKeyPress={(e) => this._searchOnKeyPress(e)}
                {...form.fullText()}>
                <Row>
                    <Col sm={8}>
                        <div className={style.content}>
                            <Tabs
                                bsStyle='cursors'
                                defaultActiveKey={1}
                                justified>
                                <Tab
                                    title={tabTitle(i18n.activities, 'customer')}
                                    eventKey={1}>
                                    <TypeaheadBar split
                                        source={activitySource}
                                        identify={(a) => a.uid}
                                        display={(a) => a.label}
                                        placeholder={extract(i18n.searchActivity, mediaQuery())}
                                        {...form.activityUid()} />
                                </Tab>
                            </Tabs>
                        </div>
                    </Col>
                </Row>
        	</SearchBar>
        )
    }
}

ProviderSearchBar = connectForm({
    target: 'criteria',
    schema: ProviderCriteria.schema,
    action: PROVIDER_CRITERIA_UPDATED
})(ProviderSearchBar)

ProviderSearchBar = connect((state) => ({
    location: state.router.location,
    criteria: state.provider.criteria,
    reference: state.reference.activityRef
}))(ProviderSearchBar)

export default ProviderSearchBar


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderSearchBar.js